import React from 'react'
import '../../Assets/Css/AddUpdateEmployee.scss' 

const AddUpdateEmployee = () => {
  return (
      <div className="addUpdateEmployee-main">
        <div className="page-title">
          <h4>Add Employee</h4>
          <div className="edit-btn">
            <button className="custom-btn">Save</button>
          </div>
        </div>
      </div>
  )
}

export default AddUpdateEmployee
